<template>
    <div class="box" id="vehicule">
        <h2><span>2/4</span> {{ t('Type de véhicule')}}</h2>
        <div class="box__inner">
            <label for="plate" v-translate>Numéro de plaque</label>
            <input v-on:input="validatePlate" v-model="number" type="text" id="plate" placeholder="AB 12 34" required>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PlateVerification',
        data: function() {
            return({
                number: this.$store.state.plateNumber
            })
        },
        methods: {
            validatePlate() {
                this.$store.commit('changeData', {
                    type: 'plateNumber',
                    value: this.number,
                });
            }
        }
    }
</script>

<style scoped>
    h2 {
        color: var(--green--dark);
        margin-bottom: 80px;
    }

    h2 span {
        display: block;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        font-size: 24px;
        margin-bottom: 15px;
    }

    .box {
        text-align: center;
        position: relative;
        padding-top: 100px;
    }

    @media only screen and (max-width: 500px) {
        .box {
            padding-top: 50px;
        }
    }

    div::before {
        content: "";
        background-color: var(--green--light);
        position: absolute;
        top: 0;
        right: -50vw;
        bottom: 0;
        left: -50vw;
        z-index: -1;
    }

    .box__inner {
        margin-right: auto;
        margin-left: auto;
        max-width: 510px;
    }

    label {
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        color: var(--green--dark);
        display: block;
        font-size: 22px;
        margin-bottom: var(--medium);
    }

    input {
        border-radius: 4px;
        border: none;
        padding: 8px var(--medium);
        width: 100%;
    }

    input::placeholder {
        color: var(--grey);
        opacity: 0.6;
    }
</style>
